// extracted by mini-css-extract-plugin
export default {"tools":"Index_tools__uwMg7"};